// extracted by mini-css-extract-plugin
export var cta = "styles-module--cta--5635c";
export var headline = "styles-module--headline--60fbd";
export var text = "styles-module--text--78b97";
export var wrapperheader = "styles-module--wrapperheader--be151";